import { StatusEnumItem } from './StatusEnumItem'
import { StatusEnum } from './statusEnum'

const RouterReview = new StatusEnumItem({
  id: '8fc9e2cf-6f2f-461d-a997-b703fc041488',
  name: 'Router Review',
  description:
    'A Router chooses which disciplines the Submittal needs to be sent to',
  priority: 0,
})

const DisciplineAction = new StatusEnumItem({
  id: '9c11dc5c-e551-4786-a993-e192a437ff3b',
  name: 'Discipline Action',
  description: 'Each Discipline reviews and approves the Submittal',
  priority: 1,
})

const ReturnedToDesignBuilder = new StatusEnumItem({
  id: 'ba40eb3e-505a-4cfa-974e-3c2889aafc02',
  name: 'Returned to Design Builder',
  description: 'The Submittal has been returned to the Design Builder',
  priority: 2,
})

const Unlocked = new StatusEnumItem({
  id: '4f20736c-385c-4b7a-90f9-e78d136e3b14',
  name: 'Unlocked',
  description:
    'The Submittal has been unlocked in CIMS and SharePoint for editing',
  priority: 3,
})

export type DSStatusItem =
  | typeof RouterReview
  | typeof DisciplineAction
  | typeof ReturnedToDesignBuilder
  | typeof Unlocked

class DSStatusEnum extends StatusEnum<
  'DSStatus',
  DSStatusItem,
  DSStatusItem['name'],
  DSStatusItem['id'],
  DSStatusItem['priority']
> {
  readonly typename = 'DSStatus'
  readonly RouterReview = RouterReview
  readonly DisciplineAction = DisciplineAction
  readonly ReturnedToDesignBuilder = ReturnedToDesignBuilder
  readonly Unlocked = Unlocked

  get values() {
    return [
      this.RouterReview,
      this.DisciplineAction,
      this.ReturnedToDesignBuilder,
      this.Unlocked,
    ]
  }
}

export const DSStatus = new DSStatusEnum()
